import { render, staticRenderFns } from "./Article_add.vue?vue&type=template&id=3afc2a96&scoped=true&"
import script from "./Article_add.vue?vue&type=script&lang=js&"
export * from "./Article_add.vue?vue&type=script&lang=js&"
import style0 from "./Article_add.vue?vue&type=style&index=0&id=3afc2a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc2a96",
  null
  
)

export default component.exports